import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getReservationSearch = get('guest.components.reservationSearch');

export const getGuestReservationSearchQuery = createSelector(
  getReservationSearch,
  get('query')
);
